import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import FrontLayout from '../containers/FrontLayout';
import ResetPasswordContent from '../components/Front/ResetPasswordContent';

const ResetPassword = ({ site, ...props }) => {
  const params = useParams();

  return (
    <FrontLayout 
      title="Reset password" 
      seoTitle={site?.site_name ? `Reset Password | ${site?.site_name || ''}` : ''}
    >
      <ResetPasswordContent token={params.token || null} />
    </FrontLayout>
  )
}

const mapStateToProps = state => {
  return {
    site: state.site
  }
}

export default connect(mapStateToProps, null)(ResetPassword);